/**
 * @Author：zsj
 * @Date：2022/01/07
 */

import Mock from './mock'

Mock.setTimeout(800);

// detail
Mock.mock(/get/, 'get', { name: 'zsj_async' });


export default Mock


